import { useQuery } from '@tanstack/react-query';

import { ApiResponse, QueryOptions } from '@cast/shared-types';
import { PermissionsCenterCloud } from '@cast/types-permissions-center';

import { apiClient } from '@cast/infrastructure-api';

const PERMISSION_CENTER_FEATURES_LIST_QUERY_KEY =
  'permission-center-features-list';

const apiFn = apiClient.permissionsCenter.listFeatures;

type Response = ApiResponse<typeof apiFn>;

type Params = {
  clouds?: PermissionsCenterCloud[];
};

type PermissionCenterFeaturesListQueryArgs = {
  params: Params;
  options?: QueryOptions<Response>;
};

export const usePermissionCenterFeaturesListQuery = (
  { params, options }: PermissionCenterFeaturesListQueryArgs = {
    params: {},
  }
) => {
  return useQuery({
    queryKey: [PERMISSION_CENTER_FEATURES_LIST_QUERY_KEY, params],
    queryFn: async () => {
      const { data } = await apiFn(params);

      return data;
    },
    ...options,
  });
};
